import SvgIcon from '@components/SvgIcon'
import { desktopCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

export interface CloseButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const StyledCloseButton = styled.button`
  && {
    display: none;

    .video-overlay-shown & {
      display: block;
      position: absolute;
      top: 13px;
      right: 3.5%;
      width: 32px;
      height: 32px;
      background: transparent;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 0;
      padding: 6;
      cursor: pointer;
      line-height: 0;
      ${desktopCSS(css`
        display: none;
      `)}
    }
  }
`

const CloseButton: FunctionComponent<CloseButtonProps> = ({ onClick }) => {
  return (
    <StyledCloseButton onClick={onClick}>
      <SvgIcon iconName="videoplayer-close" size={20} />
    </StyledCloseButton>
  )
}

export default CloseButton
